import '@/less/new/desktop/404.less';

import init from '@/js/helpers/init';

import SliderNew from '@/js/widget/SliderNew';

document.addEventListener('DOMContentLoaded', async () => {
  init('.js-slider-new', SliderNew, 'widget', 'SliderNew');
});
